var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 105,
    viewBox: "0 0 52 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.500004 97C12.363 97 24.6992 91.8902 33.7947 82.7947C42.8902 73.6992 48 61.363 48 48.5C48 35.637 42.8902 23.3008 33.7947 14.2053C24.6992 5.10981 12.363 3.84517e-07 -0.499992 -2.12e-06L-0.500002 48.5L-0.500004 97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3428 45.7666C45.2037 46.3631 45.2037 47.6369 44.3428 48.2334L31.1045 57.4043C30.1098 58.0935 28.7502 57.382 28.75 56.1719L28.75 37.8281C28.7502 36.618 30.1098 35.9065 31.1045 36.5957L44.3428 45.7666Z",
    fill: "#91E2CA",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 46.1338C34.1667 46.5187 34.1667 47.4813 33.5 47.8662L12.5 59.9902C11.8333 60.3751 11 59.8938 11 59.124L11 34.876C11 34.1062 11.8333 33.6249 12.5 34.0098L33.5 46.1338Z",
    fill: "#5DAF97",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_926",
    x: -4.5,
    y: 0,
    width: 56.5,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_926",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLeft);
export default __webpack_public_path__ + "static/media/open_left.3ec70bde0e4152094cdcdfd8de55f4bf.svg";
export { ForwardRef as ReactComponent };